import request from '@/utils/request2'

// 登录
export function login(params) {
  return request({
    url:'/app/QBZadminApi/',
    method:'get',
    params:params
  })
}

// 获取用户权限列表
export function getInfo(params) {
  return request({
    url:'/app/QBZadminApi/',
    method:'get',
    params:params
  })
}

// 退出
export function logout(params) {
  return request({
    url:'/app/QBZadminApi/',
    method:'get',
    params:params
  })
}

// 平台用户列表
export function userList(params) {
  return request({
    url:'/app/QBZadminApi/',
    method:'get',
    params:params
  })
}

// 创建用户
export function createUser(params) {
  return request({
    url:'/app/QBZadminApi/',
    method:'get',
    params:params
  })
}

// 用户详情
export function userDetail(params) {
  return request({
    url:'/app/QBZadminApi/',
    method:'get',
    params:params
  })
}

// 修改用户为白名单/黑名单
export function usersUpperLimit(params) {
  return request({
    url:'/app/QBZadminApi/',
    method:'get',
    params:params
  })
}

// 获取所有管理员列表
export function adminUserList(params) {
  return request({
    url:'/app/QBZadminApi/',
    method:'get',
    params:params
  })
}

// 获取管理员详情
export function adminInfo(params) {
  return request({
    url:'/app/QBZadminApi/',
    method:'get',
    params:params
  })
}

// 更改管理员信息
export function createOrUpdateAdmin(params) {
  return request({
    url:'/app/QBZadminApi/',
    method:'get',
    params:params
  })
}

// 获取所有菜单列表
export function getMenuList(params) {
  return request({
    url:'/app/QBZadminApi/',
    method:'get',
    params:params
  })
}

// 新建菜单
export function createOrUpdate(params) {
  return request({
    url:'/app/QBZadminApi/',
    method:'get',
    params:params
  })
}

// 删除菜单
export function deleteMenu(params) {
  return request({
    url:'/app/QBZadminApi/',
    method:'get',
    params:params
  })
}

// // 权限列表
// export function adminRoleslist(params) {
//   return request({
//     url:'/app/QBZadminApi/',
//     method:'get',
//     params:params
//   })
// }

// 登录用户修改自己的信息
export function updateUserInfo(params) {
  return request({
    url:'/app/QBZadminApi/',
    method:'get',
    params:params
  })
}




// WEBPACK FOOTER //
// ./src/api2/user.js